<script lang="ts">
	import { format } from 'date-fns'
	import { Icon } from '@repo/commons/components'

	interface Props {
		role: string
		timestamp?: Date
		duration: number
	}

	let { role, timestamp, duration }: Props = $props()
	const formatted = timestamp ? format(timestamp, 'MMMM d, HH:mm:ss') : ''

	const senderTitles: Record<typeof role, string> = {
		USER: 'User',
		ASSISTANT: 'SemanticEdge Agent'
	}
</script>

<div class="message-footer">
	<div class="sender">{senderTitles[role]}</div>
	<div class="date">
		{formatted}
		{#if duration}
			<Icon name="stopWatch" size="sm" />{duration.toFixed(2)}
		{/if}
	</div>
</div>

<style>
	.message-footer {
		@apply flex items-center justify-between gap-6 mt-3;
	}

	.message-footer .sender,
	.message-footer .date {
		@apply flex items-center gap-[7px] text-[14px] font-normal leading-5 text-[rgba(0,44,77,0.5)] capitalize;
	}
</style>
